import { Vue, Component, State, namespace, Prop } from 'nuxt-property-decorator'
import { Experience } from '~/types/experience'

import UrlQuery = Experience.UrlQuery

const experience = namespace('experience')

@Component

export default class NoneSearchResult extends Vue {
  @State klook!: Data.Klook
  @experience.State urlQuery!: UrlQuery
  @experience.State searchResultActivities!: string
  @experience.State rangeData!: any
  @experience.State destinationTitle!: string
  @experience.State categoryTitle!: string
  @Prop({ default: false }) rangeAllDisable!: boolean

  get keyword() {
    return this.urlQuery.keyword || ''
  }

  get showBackToHomePage() {
    return (this.rangeData.length <= 0 && this.searchResultActivities.length <= 0) || this.rangeAllDisable
  }

  get noResultTips() {
    const isSearchPage = this.$route.name === 'ExperienceSearch'

    if (isSearchPage) {
      if (this.urlQuery.city_ids || this.urlQuery.country_ids) {
        return this.$t('16786', { search_term: this.keyword, destination: this.destinationTitle })
      } else {
        return this.$t('48058')
      }
    } else {
      return this.$t('5303')
    }
  }

  backToExperienceHome(deepLink: string) {
    window.location.href = this.$href(deepLink || '/experiences/')
  }
}
